<template>
	<div class="tusd-wrap wrap-bg alipay">
		<div class="page-title">
			<i class="back-btn" @click="goBack"></i>
			修改随机收款方式
		</div>
		<div class="separator"></div>
		<div class="account-wrap">

			<div class="wrap-item">
				<span class="item-label">
					支付宝账号：
				</span>
				<input type="text" v-model="account.BankAccount" placeholder="请输入支付宝账号" />
			</div>
			<div class="wrap-item">
				<span class="item-label">
					支付宝UID：
				</span>
				<input type="text" v-model="account.AlipayUid" placeholder="请输入支付宝UID" />
			</div>
			<div class="wrap-item">
				<span class="item-label">
					收款方全称：
				</span>
				<input type="text" v-model="account.BankUser" placeholder="请输入收款方全称" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单日限单量：</span>
				<span class="unit">个</span>
				<input type="text" v-model="account.DayLimitOrderCount" placeholder="请输入单日限单数量" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单日总限额：</span>
				<span class="unit">元</span>
				<input type="number" v-model="account.DayLimit" placeholder="请输入单日总限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单笔最低：</span>
				<span class="unit">元</span>
				<input type="number" v-model="account.PerLimitMin" placeholder="请输入单笔最低限额" />
			</div>
				<div class="wrap-item">
				<span class="item-label">单笔最高：</span>
				<span class="unit">元</span>
				<input type="number" v-model="account.PerLimit" placeholder="请输入单笔最高限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">匹配间隔：</span>
				<span class="unit">分</span>
				<input type="number" v-model="account.SellTimeSpanLimit" placeholder="请输入距离上次间隔时间" />
			</div>
			<div class="wrap-item">
				<span class="item-label">分组管理：</span>
				<cube-select v-model="account.GroupId" :options="bankGroupOptions"
					@change="selectBankGroup"></cube-select>
			</div>
			<div class="wrap-item">
				<span class="item-label">收款人编号：</span>
				<input type="text" v-model="account.BankRemark" placeholder="请输入收款方编号" />
			</div>
			<div class="wrap-item">
				<span class="item-label">是否启用：</span>
				<div class="radio-wrap">
					<cube-radio-group @input="changeStatus" v-model="optionCheckedValue.status" :options="statusOptions"
						:horizontal="true" />
				</div>
			</div>
			 <div class="wrap-item">
          <span class="item-label">订单客户：</span>
          <div class="radio-wrap">
            <cube-radio-group
            @input="changePaymentCustomerLimit"
            v-model="optionCheckedValue.paymentCustomerLimitValue"
            :options="paymentCustomerLimitOptions"
            :horizontal="true"
            />
          </div>
        </div>
        <div class="wrap-item">
          <span class="item-label">同时进账：</span>
          <div class="radio-wrap">
            <cube-radio-group
            @input="changeIsNeedLockedOrder"
            v-model="optionCheckedValue.isNeedLockedOrderValue"
            :options="isNeedLockedOrderOptions"
            :horizontal="true"
            />
          </div>
        </div>
			<div class="wrap-item">
				<span class="item-label">展示账号：</span>
				<div class="radio-wrap">
					<cube-radio-group @input="changeShowBankAccount" v-model="optionCheckedValue.showBankAccountStatus" :options="statusOptions"
						:horizontal="true" />
				</div>
			</div>
			<div class="wrap-item">
				<span class="item-label">展示二维码：</span>
				<div class="radio-wrap">
					<cube-radio-group @input="changeShowQrCode" v-model="optionCheckedValue.showQrCodeStatus" :options="statusOptions"
						:horizontal="true" />
				</div>
			</div>
			<div class="wrap-item item_top">
				<span class="item-label">扫码支付码：</span>
				<cube-upload class="header-wrap" ref="uploadFile" :max="1" :auto="false" @files-added="filesAdded">
					<cube-upload-btn :multiple="false">
						<div id="qrCodeDiv" class="upload-btn"
							:style="{ 'background-image': 'url(' + (alipayImg ? apiURL + alipayImg : (headerImg ? headerImg : '../assets/images/header.png')) + ')' }">
							<i v-if="!headerImg && !alipayImg"></i>
						</div>
					</cube-upload-btn>
				</cube-upload>
				<button class="alipay-delete-img-btn" @click="deleteImg(1)">清除图片</button>
			</div>
			<div class="wrap-item item_top">
				<span class="item-label">转账支付码：</span>
				<cube-upload class="header-wrap" ref="uploadFile" :max="1" :auto="false"
					@files-added="transferFilesAdded">
					<cube-upload-btn :multiple="false">
						<div id="transferQRCodeDiv" class="upload-btn"
							:style="{ 'background-image': 'url(' + (alipayImg2 ? apiURL + alipayImg2 : (transferImg ? transferImg : '../assets/images/header.png')) + ')' }">
							<i v-if="!transferImg && !alipayImg2"></i>
						</div>
					</cube-upload-btn>
				</cube-upload>
				<button class="alipay-delete-img-btn" @click="deleteImg(2)">清除图片</button>
			</div>
			<div class="wrap-item item_top">
				<span class="item-label">花呗支付码：</span>
				<cube-upload class="header-wrap" ref="uploadFile" :max="1" :auto="false"
					@files-added="creditFilesAdded">
					<cube-upload-btn :multiple="false">
						<div id="creditQRCodeDiv" class="upload-btn"
							:style="{ 'background-image': 'url(' + (alipayImg3 ? apiURL + alipayImg3 : (creditImg ? creditImg : '../assets/images/header.png')) + ')' }">
							<i v-if="!creditImg && !alipayImg3"></i>
						</div>
					</cube-upload-btn>
				</cube-upload>
				<button class="alipay-delete-img-btn" @click="deleteImg(3)">清除图片</button>
			</div>
			<div class="tusd-btn first-btn" @click="addAccount">确认修改</div>
			<div class="tusd-btn tusd-btn-danger first-btn" @click="deleteBank">删除</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'editAlipay',
	data() {
		return {
			account: {
				BankUser: "",
				BankAccount: "",
				AlipayUid: "",
				PerLimit: 50000,
				DayLimit: 500000,
				id: 0,
				IsUse: 1,
				GroupId: "",
				BankRemark:"",
				qrCodeUrl: "",
				transferQRCodeUrl: "",
				creditQRCodeUrl:"",
				PerLimitMin:1000,
				DayLimitOrderCount:1,
				IsShowQrCode:1,
				IsShowBankAccount:1,
				PaymentCustomerLimit:0,
				IsNeedLockedOrder:0,
				SellTimeSpanLimit:10
			},
			bankGroupOptions: [],
			params: {},
			headerImg: "",
			alipayImg: "",
			transferImg: "",
			alipayImg2: "",
			creditImg: "",
			alipayImg3: "",
			apiURL: _IMGURL_,
			optionCheckedValue: {
				status: "否",
				showBankAccountStatus:"否",
				showQrCodeStatus:"否",
				paymentCustomerLimitValue:"全部",
				isNeedLockedOrderValue:"禁止"
			},
			statusOptions: ["是", "否"],
			status: [
				{
					label: "是",
					value: 1
				},
				{
					label: "否",
					value: 0
				}
			],
			paymentCustomerLimitOptions: ["全部","正常","新疆"],
			paymentCustomerLimitProp: [
				{
				label: "全部",
				value: 0
				},
				{
				label: "正常",
				value: 1
				}
				,
				{
				label: "新疆",
				value: 2
				}
			],
			isNeedLockedOrderOptions:["允许","禁止"],
			isNeedLockedOrderProp: [
				{
					label: "允许",
					value: 0
				},
        		{
					label: "禁止",
					value: 1
				}
			],
		};
	},
	watch: {
		"headerImg"(newVal, oldVal) {
			console.log(newVal);
			if (newVal) {
				this.filesSubmit(1)
			}
		},
		"transferImg"(newVal, oldVal) {
			console.log(newVal);
			if (newVal) {
				this.filesSubmit(2)
			}
		},
		"creditImg"(newVal, oldVal) {
			console.log(newVal);
			if (newVal) {
				this.filesSubmit(3)
			}
		}
	},
	methods: {
		getUserByBankId(bankId) {
			this.$api.getUserByBankId(bankId).then(res => {
				let data = res.data;
				this.common.copyObj(this.account, data);
				this.alipayImg = data.QRCodeUrl
				this.account.qrCodeUrl = data.QRCodeUrl
				this.alipayImg2 = data.TransferQRCodeUrl;
				this.account.transferQRCodeUrl = data.TransferQRCodeUrl;
				this.alipayImg3 = data.CreditQRCodeUrl;
				this.account.creditQRCodeUrl = data.CreditQRCodeUrl;
				this.account.id = this.params.bankId
				this.optionCheckedValue.status = this.getProp(data.IsUse, this.status, true);
				this.optionCheckedValue.showBankAccountStatus = this.getProp(data.IsShowBankAccount, this.status, true);
				this.optionCheckedValue.showQrCodeStatus = this.getProp(data.IsShowQrCode, this.status, true);
				this.optionCheckedValue.paymentCustomerLimitValue = this.getProp(data.PaymentCustomerLimit, this.paymentCustomerLimitProp, true);
       			this.optionCheckedValue.isNeedLockedOrderValue = this.getProp(data.IsNeedLockedOrder, this.isNeedLockedOrderProp, true);
			});
		},
		selectBankGroup(value, index, text) {
			this.account.groupId = value;
		},
		getUserBankGroupList() {
			let that = this;
			this.$api.getUserBankGroups().then((res) => {
				res.data.filter((item) => item.PayType == 2).map(v => {
					let temp = { text: v.Title, value: v.Id };
					that.bankGroupOptions.push(temp)
				})
			});
		},
		goBack() {
			this.$router.push({ name: this.params.back });
		},

		getProp(v, o, r) {
			let prop = '';
			o.map(i => {
				if (r) {
					if (i.value == v) {
						prop = i.label;
					}
				} else {
					if (i.label == v) {
						prop = i.value;
					}
				}
			});
			return prop;
		},
		changeStatus(v) {
			this.account.IsUse = this.getProp(v, this.status);
		},
		changeShowBankAccount(v) {
			this.account.IsShowBankAccount = this.getProp(v, this.status);
		},
		changeShowQrCode(v) {
			this.account.IsShowQrCode = this.getProp(v, this.status);
		},
		 changePaymentCustomerLimit(v) {
		  this.account.PaymentCustomerLimit = this.getProp(v, this.paymentCustomerLimitProp);
		},
		changeIsNeedLockedOrder(v) {
		  this.account.IsNeedLockedOrder = this.getProp(v, this.isNeedLockedOrderProp);
		},
		addAccount() {
			let that = this;
			if (!that.account.BankUser) {
				that.$message.popup("请输入收款方全称", 1000);
				return false
			}
			if (!that.account.BankAccount) {
				that.$message.popup("请输入支付宝账号", 1000);
				return false
			}
			// if (!that.account.AlipayUid) {
			// 	that.$message.popup("请输入支付宝UID", 1000);
			// 	return false
			// }
			if(!that.account.GroupId){
				that.$message.popup("请选择分组管理",1000);
				return false
			}
     	    if (!that.account.DayLimit  || that.account.DayLimit < 500) {
				that.$message.popup("请输入单日总限额,最低金额500", 1000);
				return false
			}
			if (!that.account.PerLimitMin  || that.account.PerLimitMin < 500) {
				that.$message.popup("请输入单笔最低限额,最低金额500", 1000);
				return false
			}
			if (!that.account.PerLimit || that.account.PerLimit < 500) {
				that.$message.popup("请输入单笔最高限额,最低金额500", 1000);
				return false
			}
     		 if (!that.account.DayLimitOrderCount || that.account.DayLimitOrderCount < 1) {
				that.$message.popup("请输入单日限单量,最少一单", 1000);
				return false
			}
            if (parseInt(that.account.PerLimit) < parseInt(that.account.PerLimitMin)) {
				that.$message.popup("单笔最高不得低于单笔最低", 1000);
				return false
			}
			if (!that.account.BankRemark) {
				that.$message.popup("请输入收款方编号", 1000);
				return false
			}
			if (that.account.IsShowBankAccount==0 && that.account.IsShowQrCode==0 ) {
				that.$message.popup("展示账号与展示二维码至少一个选择 “是” ", 1000);
				return false
			}
			if (that.account.IsShowQrCode == 1 && !that.account.qrCodeUrl && !that.account.transferQRCodeUrl && !that.account.creditQRCodeUrl) {
				that.$message.popup("展示二维码的情况下，请至少上传一个收款码", 1000);
				return false
			}
			if (!that.account.SellTimeSpanLimit ) {
				 if(parseInt(that.account.SellTimeSpanLimit) <=0 ||  parseInt(that.account.SellTimeSpanLimit)>1440) {
					that.$message.popup("匹配间隔只能设置0至一天（1440分钟）之间", 1000);
					return false
				}
			} 
			that.$api.editAlipay(that.account).then((res) => {
				that.$message.popup(res.msg, 1000);
				that.goBack();
			})
		},
		filesAdded(files) {
			let hasIgnore = false;
			const limitSize = 2 * 1024 * 1024;
			// 最大5M
			const maxSize = 5 * 1024 * 1024;
			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				// 如果选择的图片大小最大限制（这里为5M）则弹出提示
				if (file.size > maxSize) {
					file.ignore = true;
					hasIgnore = true;
					break;
				}
				// 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
				if (file.size > limitSize) {
					this.compressPic(file);
				} else {
					let reads = new FileReader();
					reads.readAsDataURL(file);
					let that = this;
					reads.onload = function (e) {
						var bdata = this.result;
						file.base64 = bdata;
						that.headerImg = bdata
						that.hasChange = true;
					};
				}
			}
			hasIgnore && this.$message.popup("图片最大支持5M", 1000);
		},
		deleteImg(index){
			var msg="您确定要清除扫码支付码？";
			if(index==2)
			{
				msg="您确定要清除转账支付码？";
			}
			else if(index==3)
			{
				msg="您确定要清除花呗支付码？";
			}
			let that = this;
			that.$message.confirm("提示", msg, () => {
				if(index==1)
				{
					that.account.qrCodeUrl="";
					that.headerImg= "";
					that.alipayImg= "";
				}
				else if(index==2)
				{
					that.account.transferQRCodeUrl="";
					that.transferImg= "";
					that.alipayImg2= "";
				}
				else if(index==3)
				{
					that.account.creditQRCodeUrl="";
					that.creditImg= "";
					that.alipayImg3= "";
				}
			});
		},
		transferFilesAdded(files) {
			let hasIgnore = false;
			const limitSize = 2 * 1024 * 1024;
			// 最大5M
			const maxSize = 5 * 1024 * 1024;
			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				// 如果选择的图片大小最大限制（这里为5M）则弹出提示
				if (file.size > maxSize) {
					file.ignore = true;
					hasIgnore = true;
					break;
				}
				// 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
				if (file.size > limitSize) {
					this.compressPic(file);
				} else {
					let reads = new FileReader();
					reads.readAsDataURL(file);
					let that = this;
					reads.onload = function (e) {
						var bdata = this.result;
						file.base64 = bdata;
						that.transferImg = bdata
						that.hasChange = true;
					};
				}
			}
			hasIgnore && this.$message.popup("图片最大支持5M", 1000);
		},
		creditFilesAdded(files) {
			let hasIgnore = false;
			const limitSize = 2 * 1024 * 1024;
			// 最大5M
			const maxSize = 5 * 1024 * 1024;
			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				// 如果选择的图片大小最大限制（这里为5M）则弹出提示
				if (file.size > maxSize) {
					file.ignore = true;
					hasIgnore = true;
					break;
				}
				// 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
				if (file.size > limitSize) {
					this.compressPic(file);
				} else {
					let reads = new FileReader();
					reads.readAsDataURL(file);
					let that = this;
					reads.onload = function (e) {
						var bdata = this.result;
						file.base64 = bdata;
						that.creditImg = bdata;
						that.hasChange = true;
					};
				}
			}
			hasIgnore && this.$message.popup("图片最大支持5M", 1000);
		},
		filesSubmit(type) {
			if (this.headerImg || this.transferImg || this.creditImg) {
				var data;
				if (type == 1) {
					data = {
						file: this.headerImg,
					}
				} else if (type == 2) {
					data = {
						file: this.transferImg,
					}
				} else {
					data = {
						file: this.creditImg,
					}
				}
				this.$api.alipayImgUpload(data).then((res) => {
					this.$message.popup("上传成功", 1000);
					if (type == 1) {
						this.account.qrCodeUrl = res.data
						this.alipayImg = res.data
					} else if (type == 2) {
						this.account.transferQRCodeUrl = res.data
						this.alipayImg2 = res.data;
					} else {
						this.account.creditQRCodeUrl = res.data
						this.alipayImg3 = res.data;
					}
				})
			}
		},
		deleteBank() {
			let that = this;
			that.$message.confirm("提示", "您确定要删除吗？", () => {
				that.$api.deleteBank(this.params.bankId).then(res => {
					that.$message.popup("删除支付宝账户成功", 1000);
					that.goBack();
				});
			});
		}
	},
	created() {
		this.params = this.$store.state.routerStore.editAlipay;
		if (!this.params.back) {
			this.params.back = 'accounts';
		}
		this.getUserByBankId(this.params.bankId);
		this.getUserBankGroupList();

	}
};
</script>
<style lang="less" scoped>
.header-wrap {
	display: inline-block;
	width: 80px;
	height: 80px;
	margin: 15px 0;

	.upload-btn {
		width: 100%;
		height: 100%;
		background: url(../assets/images/header.png) center center no-repeat;
		background-size: contain;
		border: 2px solid #cdcdcd;

		i {
			display: inline-block;
			vertical-align: middle;
			width: 75px;
			height: 80px;
			margin-right: 8px;
			background: url(../assets/images/upload.svg) center center no-repeat;
		}

	}

	.cube-upload-btn {
		height: 100%;
	}

}

.item_top {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
}
.alipay-delete-img-btn {
    background-color: #ef8299;
	margin-top: 18px;
	margin-left: 30px;
	width: 100px;
	height: 30px;
    color: #fff;
    font-size: 14px !important;
    text-align: center;
    border-radius: 4px;
}
</style>
